<template>
  <nav class="navbar is-dark" role="navigation" aria-label="main navigation">
    <div class="navbar-brand">
      <a class="navbar-item" href="http://www.osprogramadores.com/desafios">
        Os Programadores [Desafio 05]
      </a>
    </div>
    <div class="navbar-end">
      <div class="navbar-item">
        <div class="field is-grouped">
          <p class="control">
            <a href="https://github.com/vinicius73/osprogramadores-desafios"
               target="_blank" class="button is-black">
               <i class="fab fa-github"></i> Fork-it
            </a>
          </p>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
}
</script>

<style scoped>
.fab {
  margin-right: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/header.vue